export const getParagraphs = (article: string) =>
  article.split('\n').filter(x => x.trim().length > 0);
